import customAxios from "../../customAxios";
import { SEND_TO_BANK_PAY_TO_DRIVER } from "../../routes";

type Props = {
  withdrawalId: string[];
};

const sendToBankManyPayToDriver = async (props: Props) => {
  try {
    return (
      await customAxios.put(SEND_TO_BANK_PAY_TO_DRIVER , {
        withdrawalId: props.withdrawalId,
      })
    ).data;
  } catch (error: unknown) {
    console.error({SEND_TO_BANK_MANY_PAY_TO_DRIVER: error});
    return false;
  }
};

export default sendToBankManyPayToDriver;
